import mitt from 'mitt'

export type EventsType = {
  closePopup: void,
  openPopup: {
    message: string,
    type: string
  }
}

export const events = mitt<EventsType>()
